import React from 'react';

export const Chevren_downIcon = ({ fill='none', width='14', height='14' }) => {
  return (
      
    <svg width={width} height={width} viewBox="0 0 20 20" fill={fill} xmlns="http://www.w3.org/2000/svg">
      <path d="M9.99784 12.0159C9.89744 12.0159 9.804 11.9998 9.7175 11.9678C9.63099 11.9357 9.54875 11.8807 9.47079 11.8028L5.72691 8.0589C5.61156 7.94357 5.55256 7.79859 5.54989 7.62397C5.54721 7.44935 5.60622 7.3017 5.72691 7.18102C5.84759 7.06034 5.9939 7 6.16584 7C6.33778 7 6.48409 7.06034 6.60477 7.18102L9.99784 10.5741L13.3909 7.18102C13.5062 7.06568 13.6512 7.00668 13.8258 7.004C14.0004 7.00133 14.1481 7.06034 14.2688 7.18102C14.3895 7.3017 14.4498 7.44802 14.4498 7.61997C14.4498 7.79191 14.3895 7.93822 14.2688 8.0589L10.5249 11.8028C10.4469 11.8807 10.3647 11.9357 10.2782 11.9678C10.1917 11.9998 10.0982 12.0159 9.99784 12.0159Z" fill="#4B5563"/>
    </svg>


    );
};

export default Chevren_downIcon;
